// Greidi Dark Theme
export const theme = {
  bg: "#0a0f1a",
  surface: "#111827",
  card: "#1a2236",
  cardHover: "#1e2a42",
  accent: "#38bdf8",
  accentGlow: "rgba(56,189,248,0.15)",
  green: "#34d399",
  red: "#f87171",
  orange: "#fbbf24",
  purple: "#a78bfa",
  text: "#f1f5f9",
  textMuted: "#94a3b8",
  textDim: "#64748b",
  border: "#1e293b",
  inputBg: "#0f172a",
};

export const baseStyle = {
  fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
  background: theme.bg,
  color: theme.text,
  minHeight: "100vh",
  maxWidth: 480,
  margin: "0 auto",
  position: "relative",
  overflow: "hidden",
};
